/* import __COLOCATED_TEMPLATE__ from './contents.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentPreviewContents extends Component {}
